import Box, { BoxProps } from '@mui/material/Box';
import { FC, ReactNode } from 'react';

interface IProps extends BoxProps {
  children: ReactNode;
  className?: string;
}

export const BoxLayout: FC<IProps> = ({
  children,
  className,
  ...otherProps
}) => {
  return (
    <Box className={className} {...otherProps}>
      {children}
    </Box>
  );
};
